import React from 'react';
import InvestmentInfoBlock from './InvestmentInfoBlock';
import type { InvestmentInfoColumn } from '@app-types/investmentIndicators';
import './InvestmentInformationSection.less';

export interface InvestmentInformationSectionProps {
  columns: InvestmentInfoColumn[];
}

/**
 * Two-column information section: left column (Basic / Consensus / Stock
 * Attributes / Technical) and right column (Finance / Technical Indicators)
 * on desktop; stacked on mobile.
 * Figma: information root 3164:13471 (628 × 2139).
 */
const InvestmentInformationSection: React.FC<InvestmentInformationSectionProps> = ({ columns }) => (
  <div className="investment-info" data-node-id="3164:13471">
    <div className="investment-info__columns">
      {columns.map((column) => (
        <div key={column.key} className={`investment-info__column investment-info__column--${column.key}`}>
          {column.blocks.map((block) => (
            <InvestmentInfoBlock key={block.key} data={block} />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default InvestmentInformationSection;
